import Vue from 'vue'

export const CHAT_SET_CONNECTION = 'm_CHAT_SET_CONNECTION'
export const CHAT_SET_ROOMS = 'm_CHAT_SET_ROOMS'
export const CHAT_ADD_ROOM = 'CHAT_ADD_ROOM'
export const CHAT_UPDATE_ROOM = 'm_CHAT_UPDATE_ROOM'
export const CHAT_CLOSE_ROOM = 'm_CHAT_CLOSE_ROOM'
export const CHAT_SET_ROOM_PARTICIPANTS = 'm_CHAT_SET_ROOM_PARTICIPANTS'
export const CHAT_ADD_PARTICIPANT = 'm_CHAT_ADD_PARTICIPANT'
export const CHAT_REMOVE_PARTICIPANT = 'm_CHAT_REMOVE_PARTICIPANT'
export const CHAT_ADD_MESSAGE = 'm_CHAT_ADD_MESSAGE'
export const CHAT_ADD_HISTORY = 'm_CHAT_ADD_HISTORY'
export const CHAT_SET_USER_INFO = 'm_CHAT_SET_USER_INFO'
export const CHAT_READ_MESSAGE = 'm_CHAT_READ_MESSAGE'
export const CHAT_SET_NOTIFICATIONS = 'm_CHAT_SET_NOTIFICATIONS'

export default {
  [CHAT_SET_CONNECTION]: (state, connection) => {
    state.connection = connection
  },
  [CHAT_SET_ROOMS]: (state, rooms) => {
    state.rooms = rooms
  },
  [CHAT_ADD_ROOM]: (state, room) => {
    Vue.set(state.rooms, room.id, room)
  },
  [CHAT_UPDATE_ROOM]: (state, room) => {
    Vue.set(state.rooms, room.id, room)
  },
  [CHAT_CLOSE_ROOM]: (state, room) => {
    Vue.delete(state.rooms, room.id)
  },
  [CHAT_SET_ROOM_PARTICIPANTS]: (state, { room, participants }) => {
    Vue.set(state.participants, room.id, participants)
    Vue.set(state.rooms[room.id], 'participants', Object.keys(state.participants).length)
  },
  [CHAT_ADD_PARTICIPANT]: (state, { room, user }) => {
    if (!state.participants[room.id]) {
      Vue.set(state.participants, room.id, {})
    }
    Vue.set(state.participants[room.id], user.id, user)
    Vue.set(state.rooms[room.id], 'participants', Object.keys(state.participants).length)
  },
  [CHAT_REMOVE_PARTICIPANT]: (state, { room, user }) => {
    Vue.delete(state.participants[room.id], user.id)
    Vue.set(state.rooms[room.id], 'participants', Object.keys(state.participants).length)
  },
  [CHAT_ADD_MESSAGE]: (state, message) => {
    if (!state.messages[message.room.id]) {
      Vue.set(state.messages, message.room.id, [])
    }

    const existed = state.messages[message.room.id].find(m => m.message.id === message.message.id)
    if (existed) {
      return
    }

    state.messages[message.room.id].push({ ...message })
    Vue.set(state, 'notifications', state.notifications + 1)
  },
  [CHAT_READ_MESSAGE]: (state, message) => {
    Vue.delete(message, 'unread')
    Vue.set(state, 'notifications', 0)
  },
  [CHAT_SET_NOTIFICATIONS]: (state, notifications) => {
    Vue.set(state, 'notifications', notifications)
  },
  [CHAT_ADD_HISTORY]: (state, { room, history }) => {
    if (!state.messages[room.id]) {
      Vue.set(state.messages, room.id, [])
    }

    state.messages[room.id].unshift(...history)
  },
  [CHAT_SET_USER_INFO]: (state, { user, info }) => {
    Vue.set(state.users, user.id, info)
  }
}
